var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-close",on:{"click":_vm.onClose}},[_c('i',{staticClass:"el-icon-close",style:({ color: _vm.$store.state.identity === 2 ? 'rgb(234, 189, 110)' : 'rgba(67, 87, 255, 0.5)' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }